import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    landing: {
      background: '#FFF',
    },
  },
  { name: 'Landing' },
);
